import React from 'react';

class MobileNavBar extends React.Component {

    render() {
        return (
            <div className="mobile-header mobile-visible">
                <div className="mobile-logo-container">
                    <div className="mobile-site-title">{this.props.siteTitle}</div>
                </div>
                <a href="/#" className="menu-toggle mobile-visible">
                    <i className="fa fa-bars" />
                </a>
            </div>
        )
    }

}

export default MobileNavBar;